import moment from "moment";
import { GET_FEATURE_KEYS } from "./action";

const initialState = {
  featureKeys: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FEATURE_KEYS:
      const featureKeys = action.payload.map((f) =>
        Object.assign({}, f, {
          created_at: moment(f.created_at).format("LLL"),
          updated_at:
            f.updated_at !== null
              ? moment(f.updated_at).format("LLL")
              : f.updated_at,
        })
      );

      return { ...state, featureKeys: featureKeys };
    default:
      return state;
  }
};
